<template>
  <div class="d-flex flex-wrap gap-3 justify-space-between align-center">
    <div class="d-flex flex-row flex-wrap gap-3">
      <div class="d-flex flex-row flex-wrap align-center flex-md-nowrap gap-3">
        <span class="typography-body-sm-bold">Areas:</span>
        <yard-view-area-select data-testid="yard-area-select" style="min-width: 180px" />
      </div>

      <slot></slot>
    </div>

    <div
      class="d-flex flex-row flex-wrap flex-md-nowrap gap-3"
      v-if="isYMSEnabledForSelectedWarehouse && !isReadOnly">
      <v-btn data-testid="yard-subheader-add-area" variant="text" @click="addSpotArea">
        <v-icon size="small" start>mdi-plus</v-icon>
        {{ t('global.basicTerms.area') }}
      </v-btn>

      <yard-view-mode-select data-testid="yard-view-mode-select" class="ml-auto" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import useYard from '@/modules/yard/composables/useYard';
import YardViewAreaSelect from '@/modules/yard/components/Selects/YardViewAreaSelect.vue';
import YardViewModeSelect from '@/modules/yard/components/Selects/YardViewModeSelect.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewPageSubHeader',
  components: { YardViewAreaSelect, YardViewModeSelect },
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const router = useRouter();

    const addSpotArea = () =>
      router.push({
        name: 'yard-add-spot-area',
        params: { warehouseId: yardStore.defaultWarehouseIdRef.value }
      });

    return {
      t,
      addSpotArea,
      defaultWarehouseId: yardStore.defaultWarehouseIdRef,
      isReadOnly: yardStore.isReadOnlyRef,
      isYMSEnabledForSelectedWarehouse: yardStore.isYMSEnabledForSelectedWarehouse
    };
  }
});
</script>
